import React from 'react';
import { Box, Typography } from '@mui/material';

export function ErrorBox({ errors }) {
    if (!errors || errors.length === 0) {
        return <Box />;
    }

    return (
        <Box
            sx={{
                mt: 1.5,
                maxHeight: 220,
                overflowY: 'auto',
                border: '1px solid rgba(252, 165, 165, 0.7)',
                borderRadius: '18px',
                px: 2,
                py: 1.5,
                background: 'linear-gradient(180deg, rgba(127,29,29,0.14) 0%, rgba(127,29,29,0.10) 100%)',
                boxShadow: '0 14px 24px rgba(127, 29, 29, 0.06)',
            }}
        >
            {errors.map((error, index) => (
                <Typography key={index} variant='body2' sx={{ marginBottom: 1, color: '#fecaca', lineHeight: 1.65 }}>
                    <strong>{index + 1}.</strong> {typeof error === 'string' ? error : (error?.message || String(error))}
                </Typography>
            ))}
        </Box>
    );
}
